module.exports = __webpack_public_path__ + "img/thumb_28.83b9b9e5.jpg";